function getPlanFormattedDateFromMonthAndYear(month: number, year: number) {
  return `${month.toString().padStart(2, '0')}-${year}`
}

export { getPlanFormattedDateFromMonthAndYear }
